<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'states-task-help.task-states'">_Estados de la tarea</span>
  </div>
  <!-- Contenedor -->
  <div class="states-task-help__container">
    <div class="states-task-help__inner-container">
      <div class="common-diagram-card__box-container">
        <p class="common-diagram-card__title-box common-diagram-card__title-box--no-icons"
          [afTranslate]="'states-task-help.open-task'">_Abierta</p>
        <div class="common-diagram-card__icons-set common-diagram-card__icons-set--red"></div>
      </div>
      <div class="states-task-help__container-arrow">
        <span-tooltip class="states-task-help__text-arrow bottom-[0px]"
          [text]="'states-task-help.start-work' | afTranslate"></span-tooltip>
          <i class="lf-icon-step-final states-task-help__circle-arrow left-[-3px] top-[-3px]"></i>
        <hr class="states-task-help__rect-arrow" />
        <i class="lf-icon-angle-right states-task-help__icon-arrow top-[-3.5px] right-[-2px]"></i>
      </div>
      <div class="states-task-help__container-states">
        <div class="common-diagram-card__box-container">
          <p class="common-diagram-card__title-box common-diagram-card__title-box--no-icons"
            [afTranslate]="'task-edit.in-progress'">_En progreso</p>
          <div class="common-diagram-card__icons-set common-diagram-card__icons-set--yellow"></div>
        </div>
        <div class="states-task-help__container-stand-by-arrow">
          <i class="lf-icon-step-final states-task-help__circle-arrow left-[-3px] bottom-[-3px]"></i>
          <div class="states-task-help__left-top-arrow">
            <span-tooltip class="states-task-help__text-arrow top-[-16px]"
              [text]="'states-task-help.go-standby' | afTranslate"></span-tooltip>
          </div>
          <i class="lf-icon-angle-right states-task-help__icon-arrow top-[-3px] right-[-3px]"></i>
        </div>
        <div class="states-task-help__container-progress-arrow">
          <i class="lf-icon-step-final states-task-help__circle-arrow right-[-4px] top-[-3px]"></i>
          <div class="states-task-help__left-top-arrow">
            <span-tooltip class="states-task-help__text-arrow"
              [text]="'states-task-help.start-work' | afTranslate"></span-tooltip>
          </div>
          <i class="lf-icon-angle-down states-task-help__icon-arrow left-[-3.5px] bottom-[-3px]"></i>
        </div>
        <div class="states-task-help__container-unresolved">
          <i class="lf-icon-step-final states-task-help__circle-arrow left-[-3px] top-[-3px]"></i>
          <div class="states-task-help__left-bottom-arrow">
            <span-tooltip class="states-task-help__text-arrow"
              [text]="'states-task-help.unsolved' | afTranslate"></span-tooltip>
          </div>
          <i class="lf-icon-angle-right states-task-help__icon-arrow right-[-3px] bottom-[-4px]"></i>
        </div>
        <div class="states-task-help__container-reopen">
          <i class="lf-icon-step-final states-task-help__circle-arrow right-[-3px] top-[-6px]"></i>
          <div class="states-task-help__all-less-top-arrow">
            <span-tooltip class="states-task-help__text-arrow"
              [text]="'states-task-help.reopen' | afTranslate"></span-tooltip>
          </div>
          <i class="lf-icon-angle-up states-task-help__icon-arrow left-[-3.5px] top-[-2px]"></i>
        </div>
      </div>
      <div class="states-task-help__container-arrow">
        <span-tooltip class="states-task-help__text-arrow bottom-[0px]"
          [text]="'states-task-help.solve' | afTranslate"></span-tooltip>
        <i class="lf-icon-step-final states-task-help__circle-arrow left-[-3px] top-[-3px]"></i>
        <hr class="states-task-help__rect-arrow" />
        <i class="lf-icon-angle-right states-task-help__icon-arrow top-[-3.5px] right-[-2px]"></i>
      </div>
      <div class="states-task-help__container-states">
        <div class="states-task-help__box-container-stand-by">
          <p class="common-diagram-card__title-box common-diagram-card__title-box--no-icons"
            [afTranslate]="'states-task-help.stand-by-task'">_Stand by</p>
          <div class="common-diagram-card__icons-set common-diagram-card__icons-set--orange"></div>
        </div>
        <div class="common-diagram-card__box-container">
          <p class="common-diagram-card__title-box common-diagram-card__title-box--no-icons"
            [afTranslate]="'states-task-help.solved-task'">_Resuelta</p>
          <div class="common-diagram-card__icons-set common-diagram-card__icons-set--green"></div>
        </div>
      </div>
      <div class="states-task-help__container-arrow">
        <span-tooltip class="states-task-help__text-arrow bottom-[0px]"
          [text]="'common.close' | afTranslate"></span-tooltip>
          <i class="lf-icon-step-final states-task-help__circle-arrow left-[-3px] top-[-3px]"></i>
        <hr class="states-task-help__rect-arrow" />
        <i class="lf-icon-angle-right states-task-help__icon-arrow top-[-3.5px] right-[-2px]"></i>
      </div>
      <div class="states-task-help__container-states">
        <div class="common-diagram-card__box-container">
          <p class="common-diagram-card__title-box common-diagram-card__title-box--no-icons"
            [afTranslate]="'states-task-help.closed-task'">_Cerrada</p>
          <div class="common-diagram-card__icons-set common-diagram-card__icons-set--grey"></div>
        </div>
        <div class="states-task-help__box-container-closed-unresolved">
          <p class="common-diagram-card__title-box common-diagram-card__title-box--no-icons"
            [afTranslate]="'states-task-help.closed-unresolved-task'">_Cerrada sin resolver</p>
          <div class="common-diagram-card__icons-set common-diagram-card__icons-set--brown"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'">_Cerrar</span>
    </button>
  </div>
</div>
